import React, { memo } from "react";
import AdminLayout from "layouts/AdminLayout";
import ShopLayout from "layouts/ShopLayout";
import { useSelector } from "react-redux";
import { selectPreloader } from "features/authentication/authSlice";
import userStorage from "store/UserStorage";
import Preloader from "components/Preloader/Preloader";
import styled from "styled-components/macro";

function App() {
  const preload = useSelector(selectPreloader);
  let token = userStorage.getUser();

  return preload ? (
    <LoadingContainer>
      <Preloader />
    </LoadingContainer>
  ) : token ? (
    <AdminLayout />
  ) : (
    <ShopLayout />
  );
}

export default memo(App);
const LoadingContainer = styled.div`
  display: inline-flex;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
`;
